const hostname = window.location.hostname
const isLocal = hostname.includes('.devbox.')
const isDev = !isLocal && (hostname.includes('bejusto.com') || process.env.REACT_APP_DOMAIN)
const isProduction = !isDev && (hostname.includes('.com') || hostname.includes('.io'))

const forceProd = !!process.env.REACT_APP_FORCE_PRODUCTION

export default () => (!isLocal && (isProduction || forceProd) ? 'prod' : isDev ? 'dev' : 'local')
